export enum PlacesAutocompleteActionEnum {
  EnterPressed = 1,
  MouseClicked = 2,
  InputBlurred = 3
}
